var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sprint-7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,12.3561379 L2.84519113,19.5109467 C2.52229145,19.8359263 2.09525879,19.9984188 1.66818881,19.9984188 L1.66813548,19.9984188 C1.24107615,19.9984188 0.813995502,19.8359263 0.489053265,19.5109467 C-0.163017755,18.8588757 -0.163017755,17.8068799 0.489053265,17.1548089 L7.64386214,10 L0.489053265,2.84519113 C-0.163017755,2.19312011 -0.163017755,1.14112429 0.489053265,0.489053265 C1.14112429,-0.163017755 2.19312011,-0.163017755 2.84519113,0.489053265 L10,7.64386214 L17.1548089,0.489053265 C17.8068799,-0.163017755 18.8588757,-0.163017755 19.5109467,0.489053265 C20.1630178,1.14112429 20.1630178,2.19312011 19.5109467,2.84519113 L12.3561379,10 L19.5109467,17.1548089 C20.1630178,17.8068799 20.1630178,18.8588757 19.5109467,19.5109467 C19.1880471,19.8359263 18.7610144,19.9984188 18.3339444,19.9984188 L18.3338911,19.9984188 C17.9068318,19.9984188 17.4797511,19.8359263 17.1548089,19.5109467 L10,12.3561379 Z",
    id: "close",
    fill: "#BDD23F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menu-close.9e4536a5911b7280e1df1800243715e8.svg";
export { ForwardRef as ReactComponent };